const CAP7_CONSENSO = {
  id: 7,
  slug: "cap7-consenso-blockchain",
  title: "Capítulo 7 — ¿Cómo funciona el consenso en una blockchain?",
  sections: [
    {
      heading: "¿Qué es el consenso?",
      text: [
        "El consenso es el mecanismo que permite que muchos nodos, ubicados en distintas partes del mundo, se pongan de acuerdo sobre el estado de una blockchain sin necesidad de una autoridad central.",
        "Es lo que permite que la blockchain funcione de forma descentralizada, segura y confiable."
      ]
    },
    {
      heading: "Pasos del consenso (explicado para todo público)",
      text: [
        "Así fluye una transacción desde que alguien la envía hasta que queda confirmada en la blockchain:"
      ],
      subsections: [
        {
          heading: " Creación de la transacción",
          list: [
            "El usuario envía criptomonedas o interactúa con una aplicación (DApp).",
            "La transacción incluye remitente, destinatario, cantidad y firma digital."
          ]
        },
        {
          heading: " Difusión a la red",
          list: [
            "La transacción se transmite a diferentes nodos de la red.",
            "Cada nodo la almacena temporalmente en una lista llamada mempool."
          ]
        },
        {
          heading: " Verificación",
          list: [
            "Se comprueba que el remitente tiene fondos suficientes.",
            "Se valida la firma digital para garantizar que el remitente autorizó la transacción.",
            "Se confirma que no hay doble gasto (double spending)."
          ]
        },
        {
          heading: " Construcción del bloque",
          list: [
            "Varias transacciones verificadas se agrupan en un nuevo bloque.",
            "El bloque se vincula al bloque anterior mediante un hash.",
            "El bloque queda listo para ser evaluado por la red."
          ]
        },
        {
          heading: " Consenso: aquí ocurre la validación",
          text: [
            "Dependiendo del algoritmo de consenso, los nodos validadores eligen quién agregará el bloque:"
          ],
          list: [
            "En PoW: los mineros compiten resolviendo un problema matemático.",
            "En PoS: los validadores son elegidos según sus fondos en staking.",
            "En DPoS: los delegados votados por la comunidad validan los bloques.",
            "En PoH: el orden del tiempo ayuda a validar las transacciones más rápido."
          ]
        },
        {
          heading: " Adición y registro final",
          bluepoints: [
            "📌 El bloque se agrega de forma permanente a la blockchain.",
            "🧾 Todos los nodos actualizan su copia del libro mayor.",
            "🔒 La transacción queda confirmada, es válida e **inmutable**."
          ]
        }
      ]
    },
    {
      heading: "¿Por qué este proceso es tan importante?",
      bluepoints: [
        "⭐ No depende de bancos, gobiernos ni servidores centrales.",
        "🔐 Aporta seguridad, transparencia e integridad a las transacciones.",
        "🚫 Evita la censura y el doble gasto.",
        "🤝 Permite que personas que no se conocen puedan confiar en el sistema."
      ]
    },
    {
  
      note: [
        "El consenso es el corazón de la blockchain.",
        "Permite que miles de nodos lleguen a un acuerdo sin intermediarios.",
        "Es lo que hace que las transacciones sean seguras, transparentes e irreversibles."
      ],
       },
       {
      bluepoints: [
        "💡 Sin consenso, no hay blockchain."
      ]
    }
  ]
};

export default CAP7_CONSENSO;
